var _g, _path, _g2, _path2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalInviteUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_185_4213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    stroke: "url(#paint0_linear_185_4213)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_185_4213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_4213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 45,
    width: 43,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3526 45H40V91.1052H82.3526V45Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3111 71.8965H54.0418C51.7226 71.8995 49.4992 72.9039 47.8594 74.6891C46.2195 76.4744 45.2969 78.8946 45.2942 81.4192V91.1071H77.0586V81.4192C77.0556 78.8946 76.1332 76.4744 74.4933 74.6891C72.8534 72.9039 70.6303 71.8995 68.3111 71.8965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1765 68.0526C67.0241 68.0526 71.7646 62.8921 71.7646 56.5264C71.7646 50.1605 67.0241 45 61.1765 45C55.3288 45 50.5884 50.1605 50.5884 56.5264C50.5884 62.8921 55.3288 68.0526 61.1765 68.0526Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_185_4213)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_185_4213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 59,
    width: 44,
    height: 47
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59.8945H69.6477V106H112V59.8945Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_185_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.354 91.3217V93.2442H109.838C109.627 95.9581 108.541 98.5032 106.774 100.429C105.005 102.355 102.669 103.538 100.177 103.768V99.9719H98.4125V103.768C95.9213 103.538 93.5846 102.355 91.8167 100.429C90.0487 98.5032 88.963 95.9581 88.7518 93.2442H92.2362V91.3217H88.7518C88.9468 88.818 89.886 86.4578 91.4186 84.595H86.8662C84.5471 84.598 82.3237 85.603 80.6838 87.3892C79.044 89.1755 78.1215 91.5974 78.1187 94.1233V103.818H109.883V94.1233C109.882 93.1649 109.748 92.2214 109.494 91.3217H106.354ZM100.177 93.2442H101.942V91.3217H100.177V89.3995H98.4125V91.3217H96.6478V93.2442H98.4125V95.1664H100.177V93.2442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0972 82.9473C100.945 82.9473 105.685 77.7867 105.685 71.421C105.685 65.0551 100.945 59.8945 95.0972 59.8945C89.2495 59.8945 84.509 65.0551 84.509 71.421C84.509 77.7867 89.2495 82.9473 95.0972 82.9473Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_185_4213",
    x: -24,
    y: -24,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_185_4213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_185_4213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_185_4213",
    x: 45.2942,
    y: 45,
    width: 31.7644,
    height: 50.1052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_185_4213"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_185_4213",
    x: 78.1187,
    y: 59.8945,
    width: 31.7646,
    height: 47.9231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_185_4213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_4213",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalInviteUsers);
export default __webpack_public_path__ + "static/media/Goal-Invite-Users.c9eb07126d054aa6d4496561cb8fdd2c.svg";
export { ForwardRef as ReactComponent };